import styled from "styled-components";
import { mainFont, black } from "../../utils/StyleHelpers";

export const StyledSearchLabel = styled.div`
  color: ${black};
  font-family: ${mainFont};
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 1.5rem;
`;
